module.exports = __webpack_public_path__ + "static/media/medibank_feature@2x.e860ba95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/medibank/medibank_feature@2x.jpg
// module id = 207
// module chunks = 0